import { get } from 'lodash';

const defaultDimension = (eventName) => {
  const eventToDimension = {
    conviva_button_click: ['button_click_text'],
    conviva_screen_view: ['screen_title'],
    conviva_page_view: ['page_title'],
    conviva_link_click: ['request_target_url', 'link_click_element_target'],
    conviva_network_request: [
      'network_request_url_host',
      'network_request_url_path',
      'network_request_response_code',
    ],
  };
  return get(eventToDimension, eventName, ['']);
};

export const getDefaultBreakdownEvent = (node, customerDimensionList) => {
  let defaultDimensions = defaultDimension(node.event_name);
  // customer should also have default dimensions.
  defaultDimensions = defaultDimensions.filter((dim) =>
    customerDimensionList.find((item) => item.dimension_name === dim),
  );
  const breakdowns = defaultDimensions.map((d) => [
    {
      field: d,
      op: 'eq',
      is_all: d && true,
      value: [],
    },
  ]);
  return {
    event_name: node.event_name,
    breakdowns,
  };
};

export const getSingleBreakdownEvent = (node, appliedEventBreakdown, eventIndex, dimensionList) => {
  const defaultEventBreakdown = getDefaultBreakdownEvent(node, dimensionList);
  const appliedDimension = appliedEventBreakdown[eventIndex].breakdowns.map((b) => b[0].field);
  // if applied dimension does not contains default dimension
  // then add the left out dimension for breakdown
  const leftDefaultDimension = defaultEventBreakdown.breakdowns.filter(
    (b) => !appliedDimension.includes(b[0].field),
  );
  if (!leftDefaultDimension.length) {
    return [
      [
        {
          field: '',
          op: 'eq',
          value: [],
        },
      ],
    ];
  }
  return leftDefaultDimension;
};

const isChromeHighVersion = () => {
  const ua = navigator.userAgent.toLowerCase();
  const chromeIndex = ua.indexOf('chrome');
  if (chromeIndex > -1) {
    const version = ua.substring(chromeIndex + 7);
    const majorVersion = parseInt(version.split('.')[0], 10);
    return majorVersion > 127;
  }
  return false;
};

const isFirefoxHighVersion = () => {
  const ua = navigator.userAgent.toLowerCase();
  const firefoxIndex = ua.indexOf('firefox');
  if (firefoxIndex > -1) {
    const version = ua.substring(firefoxIndex + 8);
    const majorVersion = parseInt(version.split('.')[0], 10);
    return majorVersion > 129;
  }
  return false;
};

export const doNotZoom = () => {
  // on latest browser nodedropdown messes up
  return isFirefoxHighVersion() || isChromeHighVersion();
};
